import React, { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom'
import { Content, Footer, Header, Sidebar } from './index';


const authRoutes = ['/login']
const MainLayout = ({ children, breakpoint }) => {
    // hooks
    const { pathname } = useLocation();

    const isSidebarOpen = () => {
        return document
            .querySelector('.cr-sidebar')
            .classList.contains('cr-sidebar--open');
    }

    const openSidebar = (openOrClose) => {
        if (openOrClose === 'open') {
            return document
                .querySelector('.cr-sidebar')
                .classList.add('cr-sidebar--open');
        }
        document.querySelector('.cr-sidebar').classList.remove('cr-sidebar--open');
    }

    const handleContentClick = event => {
        if (isSidebarOpen() && (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md')) {
            openSidebar('close');
        }
    };

    const checkBreakpoint = useCallback(() => {
        switch (breakpoint) {
            case 'xs':
            case 'sm':
            case 'md':
                return openSidebar('close');

            case 'lg':
            case 'xl':
            default:
                return openSidebar('open');
        }
    }, [breakpoint]);

    useEffect(() => {
        if (!authRoutes.includes(pathname)) checkBreakpoint()
    }, [pathname, breakpoint, checkBreakpoint])

    if (!authRoutes.includes(pathname)) {
        return (
            <main className="cr-app bg-light">
                <Sidebar />
                <Content fluid onClick={handleContentClick}>
                    <Header />
                    {children}
                    {/* <Footer /> */}
                </Content>
            </main>
        )
    } else return children;
}

export default MainLayout;
